import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function SharingComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.showIcon ? "" : "no-icon");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.socialMedia.tag, "");
} }
function SharingComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function SharingComponent_ng_template_3_div_0_lib_fb_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-fb-icon", 10);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("urlLink", ctx_r7.socialMedia.urlLink);
} }
function SharingComponent_ng_template_3_div_0_lib_ln_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-ln-icon", 10);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("urlLink", ctx_r8.socialMedia.urlLink);
} }
function SharingComponent_ng_template_3_div_0_lib_tw_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-tw-icon", 11);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("urlLink", ctx_r9.socialMedia.urlLink);
} }
function SharingComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, SharingComponent_ng_template_3_div_0_lib_fb_icon_1_Template, 1, 1, "lib-fb-icon", 8);
    ɵngcc0.ɵɵtemplate(2, SharingComponent_ng_template_3_div_0_lib_ln_icon_2_Template, 1, 1, "lib-ln-icon", 8);
    ɵngcc0.ɵɵtemplate(3, SharingComponent_ng_template_3_div_0_lib_tw_icon_3_Template, 1, 1, "lib-tw-icon", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.socialMedia.isFaceBook);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.socialMedia.isLinkedIn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.socialMedia.isTwitter);
} }
function SharingComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SharingComponent_ng_template_3_div_0_Template, 4, 3, "div", 6);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showIcon);
} }
function SharingComponent_ng_template_5_div_0_lib_fb_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-fb-icon", 10);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("urlLink", ctx_r11.socialMedia.urlLink);
} }
function SharingComponent_ng_template_5_div_0_lib_ln_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-ln-icon", 10);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("urlLink", ctx_r12.socialMedia.urlLink);
} }
function SharingComponent_ng_template_5_div_0_lib_tw_icon_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-tw-icon", 11);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("urlLink", ctx_r13.socialMedia.urlLink);
} }
function SharingComponent_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "span", 14);
    ɵngcc0.ɵɵlistener("mouseover", function SharingComponent_ng_template_5_div_0_Template_span_mouseover_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.popupOpen(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵlistener("mouseover", function SharingComponent_ng_template_5_div_0_Template_div_mouseover_2_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.setCount(); })("mouseleave", function SharingComponent_ng_template_5_div_0_Template_div_mouseleave_2_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.popupClos(); });
    ɵngcc0.ɵɵtemplate(3, SharingComponent_ng_template_5_div_0_lib_fb_icon_3_Template, 1, 1, "lib-fb-icon", 8);
    ɵngcc0.ɵɵtemplate(4, SharingComponent_ng_template_5_div_0_lib_ln_icon_4_Template, 1, 1, "lib-ln-icon", 8);
    ɵngcc0.ɵɵtemplate(5, SharingComponent_ng_template_5_div_0_lib_tw_icon_5_Template, 1, 1, "lib-tw-icon", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r10.socialMedia.isOpen ? "open" : "close");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.socialMedia.isFaceBook);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.socialMedia.isLinkedIn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.socialMedia.isTwitter);
} }
function SharingComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SharingComponent_ng_template_5_div_0_Template, 6, 4, "div", 12);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.showIcon);
} }
class SharingService {
    constructor() { }
}
SharingService.ɵfac = function SharingService_Factory(t) { return new (t || SharingService)(); };
SharingService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SharingService_Factory() { return new SharingService(); }, token: SharingService, providedIn: "root" });
SharingService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SharingComponent {
    constructor() {
        this.isOverPopup = false;
        this.showCategory = true;
        this.showIcon = true;
    }
    ngOnInit() {
        if (this.whatShare) {
            if (this.whatShare.category != undefined) {
                this.showCategory = this.whatShare.category;
            }
            if (this.whatShare.shareIcon != undefined) {
                this.showIcon = this.whatShare.shareIcon;
            }
        }
    }
    popupOpen() {
        // @ts-ignore
        this.socialMedia.isOpen = true;
        setTimeout(() => {
            if (!this.isOverPopup) {
                this.socialMedia.isOpen = false;
            }
        }, 3000);
    }
    popupClos() {
        this.socialMedia.isOpen = false;
        this.isOverPopup = false;
    }
    setCount() {
        this.isOverPopup = true;
    }
}
SharingComponent.ɵfac = function SharingComponent_Factory(t) { return new (t || SharingComponent)(); };
SharingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SharingComponent, selectors: [["lib-sharing"]], inputs: { socialMedia: "socialMedia", whatShare: "whatShare" }, decls: 7, vars: 4, consts: [[1, "sharing-wrapper"], ["class", "social-media-tag", 3, "ngClass", 4, "ngIf"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["no_popup", ""], ["popup", ""], [1, "social-media-tag", 3, "ngClass"], ["class", "social-media-container", 4, "ngIf"], [1, "social-media-container"], ["class", "social-media-item", 3, "urlLink", 4, "ngIf"], ["class", "social-media-item last", 3, "urlLink", 4, "ngIf"], [1, "social-media-item", 3, "urlLink"], [1, "social-media-item", "last", 3, "urlLink"], ["class", "social-media-container popper-wrapper", 4, "ngIf"], [1, "social-media-container", "popper-wrapper"], [1, "social-media-icon", 3, "mouseover"], [1, "social-media-share", 3, "ngClass", "mouseover", "mouseleave"]], template: function SharingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SharingComponent_div_1_Template, 3, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SharingComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, SharingComponent_ng_template_3_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, SharingComponent_ng_template_5_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(4);
        const _r4 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.socialMedia.tag && ctx.showCategory);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.socialMedia.isPopup)("ngIfThen", _r4)("ngIfElse", _r2);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgClass, FbIconComponent, LnIconComponent, TwIconComponent]; }, styles: [".sharing-wrapper[_ngcontent-%COMP%]   .social-media-item[_ngcontent-%COMP%]{margin-right:10px}.sharing-wrapper[_ngcontent-%COMP%]   .social-media-item.last[_ngcontent-%COMP%]{margin-right:0}.sharing-wrapper[_ngcontent-%COMP%]   .social-media-tag[_ngcontent-%COMP%]{display:inline-block;margin-right:10px;padding-right:10px;border-right:1px solid #000}.sharing-wrapper[_ngcontent-%COMP%]   .social-media-tag.no-icon[_ngcontent-%COMP%]{border:none}.sharing-wrapper[_ngcontent-%COMP%]   .social-media-container[_ngcontent-%COMP%]{display:inline-block;position:relative}.sharing-wrapper[_ngcontent-%COMP%]   .social-media-container[_ngcontent-%COMP%]   .social-media-icon[_ngcontent-%COMP%]{background-image:url(/assets/sns-share.svg);width:20px;height:20px;display:block;background-size:contain;position:relative;vertical-align:middle;cursor:pointer;background-repeat:no-repeat;background-position:50%}.sharing-wrapper[_ngcontent-%COMP%]   .popper-wrapper[_ngcontent-%COMP%]   .social-media-share[_ngcontent-%COMP%]{position:absolute}.sharing-wrapper[_ngcontent-%COMP%]   .popper-wrapper[_ngcontent-%COMP%]   .social-media-share.close[_ngcontent-%COMP%]{display:none}.sharing-wrapper[_ngcontent-%COMP%]   .popper-wrapper[_ngcontent-%COMP%]   .social-media-share.open[_ngcontent-%COMP%]{display:block;left:-20px;top:-52px;width:112px;background-color:#e1dddd;padding:5px 10px;border-radius:5px}.sharing-wrapper[_ngcontent-%COMP%]   .popper-wrapper[_ngcontent-%COMP%]   .social-media-share.open[_ngcontent-%COMP%]:after{content:\"\";display:inline-block;position:absolute;left:22%;bottom:-10px;width:0;height:0;border-style:solid;border-width:10px 10px 0 10px;border-color:#e1dddd transparent transparent transparent}"] });
SharingComponent.ctorParameters = () => [];
SharingComponent.propDecorators = {
    socialMedia: [{ type: Input }],
    whatShare: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharingComponent, [{
        type: Component,
        args: [{
                selector: 'lib-sharing',
                template: "<div class=\"sharing-wrapper\">\r\n  <div class=\"social-media-tag\" *ngIf=\"socialMedia.tag && showCategory\" [ngClass]=\"showIcon?'':'no-icon'\">\r\n    <span> {{ socialMedia.tag }}</span>\r\n  </div>\r\n  <ng-container *ngIf=\"socialMedia.isPopup; then popup; else no_popup\">\r\n  </ng-container>\r\n  <ng-template #no_popup>\r\n    <div class=\"social-media-container\" *ngIf=\"showIcon\">\r\n      <lib-fb-icon  class=\"social-media-item\" *ngIf=\"socialMedia.isFaceBook\" [urlLink]=\"socialMedia.urlLink\"></lib-fb-icon>\r\n      <lib-ln-icon  class=\"social-media-item\" *ngIf=\"socialMedia.isLinkedIn\" [urlLink]=\"socialMedia.urlLink\"></lib-ln-icon>\r\n      <lib-tw-icon  class=\"social-media-item last\" *ngIf=\"socialMedia.isTwitter\" [urlLink]=\"socialMedia.urlLink\"></lib-tw-icon>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #popup>\r\n    <div class=\"social-media-container popper-wrapper\" *ngIf=\"showIcon\">\r\n      <span class=\"social-media-icon\" (mouseover)=\"popupOpen()\"></span>\r\n      <div class=\"social-media-share\" [ngClass]=\"socialMedia.isOpen? 'open' : 'close'\" (mouseover)=\"setCount()\" (mouseleave)=\"popupClos()\">\r\n        <lib-fb-icon class=\"social-media-item\"  *ngIf=\"socialMedia.isFaceBook\" [urlLink]=\"socialMedia.urlLink\" ></lib-fb-icon>\r\n        <lib-ln-icon class=\"social-media-item\" *ngIf=\"socialMedia.isLinkedIn\" [urlLink]=\"socialMedia.urlLink\"></lib-ln-icon>\r\n        <lib-tw-icon class=\"social-media-item last\" *ngIf=\"socialMedia.isTwitter\" [urlLink]=\"socialMedia.urlLink\"></lib-tw-icon>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n",
                styles: [".sharing-wrapper .social-media-item{margin-right:10px}.sharing-wrapper .social-media-item.last{margin-right:0}.sharing-wrapper .social-media-tag{display:inline-block;margin-right:10px;padding-right:10px;border-right:1px solid #000}.sharing-wrapper .social-media-tag.no-icon{border:none}.sharing-wrapper .social-media-container{display:inline-block;position:relative}.sharing-wrapper .social-media-container .social-media-icon{background-image:url(/assets/sns-share.svg);width:20px;height:20px;display:block;background-size:contain;position:relative;vertical-align:middle;cursor:pointer;background-repeat:no-repeat;background-position:50%}.sharing-wrapper .popper-wrapper .social-media-share{position:absolute}.sharing-wrapper .popper-wrapper .social-media-share.close{display:none}.sharing-wrapper .popper-wrapper .social-media-share.open{display:block;left:-20px;top:-52px;width:112px;background-color:#e1dddd;padding:5px 10px;border-radius:5px}.sharing-wrapper .popper-wrapper .social-media-share.open:after{content:\"\";display:inline-block;position:absolute;left:22%;bottom:-10px;width:0;height:0;border-style:solid;border-width:10px 10px 0 10px;border-color:#e1dddd transparent transparent transparent}\n"]
            }]
    }], function () { return []; }, { socialMedia: [{
            type: Input
        }], whatShare: [{
            type: Input
        }] }); })();

class FbIconComponent {
    constructor() { }
    ngOnInit() {
    }
}
FbIconComponent.ɵfac = function FbIconComponent_Factory(t) { return new (t || FbIconComponent)(); };
FbIconComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FbIconComponent, selectors: [["lib-fb-icon"]], inputs: { urlLink: "urlLink" }, decls: 3, vars: 1, consts: [["title", "Facebook", "target", "_blank", "rel", "nofollow noopener", "onclick", "window.open(this.href,'targetWindow',\n                                   `toolbar=no,\n                                    location=no,\n                                    status=no,\n                                    menubar=no,\n                                    scrollbars=yes,\n                                    resizable=yes,\n                                    width=SomeSize,\n                                    height=SomeSize`); return false;", 1, "facebook-share-button", 3, "href"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24"], ["d", "M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"]], template: function FbIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.urlLink, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [""] });
FbIconComponent.ctorParameters = () => [];
FbIconComponent.propDecorators = {
    urlLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FbIconComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-icon',
                template: "<a\r\n    href=\"{{ urlLink }}\"\r\n    class=\"facebook-share-button\"\r\n    title=\"Facebook\"\r\n    target=\"_blank\"\r\n    rel=\"nofollow noopener\"\r\n    onclick=\"window.open(this.href,'targetWindow',\r\n                                   `toolbar=no,\r\n                                    location=no,\r\n                                    status=no,\r\n                                    menubar=no,\r\n                                    scrollbars=yes,\r\n                                    resizable=yes,\r\n                                    width=SomeSize,\r\n                                    height=SomeSize`); return false;\"\r\n>\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z\"/></svg>\r\n</a>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { urlLink: [{
            type: Input
        }] }); })();

class TwIconComponent {
    constructor() { }
    ngOnInit() {
    }
}
TwIconComponent.ɵfac = function TwIconComponent_Factory(t) { return new (t || TwIconComponent)(); };
TwIconComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TwIconComponent, selectors: [["lib-tw-icon"]], inputs: { urlLink: "urlLink" }, decls: 3, vars: 1, consts: [["title", "Twiter", "target", "_blank", "rel", "nofollow noopener", "onclick", "window.open(this.href,'targetWindow',\n                                   `toolbar=no,\n                                    location=no,\n                                    status=no,\n                                    menubar=no,\n                                    scrollbars=yes,\n                                    resizable=yes,\n                                    width=SomeSize,\n                                    height=SomeSize`); return false;", 1, "twitter-share-button", 3, "href"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24"], ["d", "M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"]], template: function TwIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.urlLink, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [""] });
TwIconComponent.ctorParameters = () => [];
TwIconComponent.propDecorators = {
    urlLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TwIconComponent, [{
        type: Component,
        args: [{
                selector: 'lib-tw-icon',
                template: "<a\r\n    href=\"{{ urlLink }}\"\r\n    class=\"twitter-share-button\"\r\n    title=\"Twiter\"\r\n    target=\"_blank\"\r\n    rel=\"nofollow noopener\"\r\n    onclick=\"window.open(this.href,'targetWindow',\r\n                                   `toolbar=no,\r\n                                    location=no,\r\n                                    status=no,\r\n                                    menubar=no,\r\n                                    scrollbars=yes,\r\n                                    resizable=yes,\r\n                                    width=SomeSize,\r\n                                    height=SomeSize`); return false;\"\r\n>\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n    <path d=\"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z\"/>\r\n  </svg>\r\n</a>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { urlLink: [{
            type: Input
        }] }); })();

class LnIconComponent {
    constructor() { }
    ngOnInit() {
    }
}
LnIconComponent.ɵfac = function LnIconComponent_Factory(t) { return new (t || LnIconComponent)(); };
LnIconComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LnIconComponent, selectors: [["lib-ln-icon"]], inputs: { urlLink: "urlLink" }, decls: 3, vars: 1, consts: [["title", "LinkedIn", "target", "_blank", "rel", "nofollow noopener", "onclick", "window.open(this.href,'targetWindow',\n                                   `toolbar=no,\n                                    location=no,\n                                    status=no,\n                                    menubar=no,\n                                    scrollbars=yes,\n                                    resizable=yes,\n                                    width=SomeSize,\n                                    height=SomeSize`); return false;", 1, "linkedIn-share-button", 3, "href"], ["xmlns", "http://www.w3.org/2000/svg", "width", "24", "height", "24", "viewBox", "0 0 24 24"], ["d", "M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"]], template: function LnIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelement(2, "path", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.urlLink, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [""] });
LnIconComponent.ctorParameters = () => [];
LnIconComponent.propDecorators = {
    urlLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LnIconComponent, [{
        type: Component,
        args: [{
                selector: 'lib-ln-icon',
                template: "<a\r\n    href=\"{{ urlLink }}\"\r\n    class=\"linkedIn-share-button\"\r\n    title=\"LinkedIn\"\r\n    target=\"_blank\"\r\n    rel=\"nofollow noopener\"\r\n    onclick=\"window.open(this.href,'targetWindow',\r\n                                   `toolbar=no,\r\n                                    location=no,\r\n                                    status=no,\r\n                                    menubar=no,\r\n                                    scrollbars=yes,\r\n                                    resizable=yes,\r\n                                    width=SomeSize,\r\n                                    height=SomeSize`); return false;\"\r\n>\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\r\n    <path d=\"M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z\"/>\r\n  </svg>\r\n</a>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { urlLink: [{
            type: Input
        }] }); })();

const components = [
    SharingComponent,
    FbIconComponent,
    TwIconComponent,
    LnIconComponent,
];
class SharingModule {
}
SharingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SharingModule });
SharingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SharingModule_Factory(t) { return new (t || SharingModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharingModule, { declarations: function () { return [SharingComponent, FbIconComponent, TwIconComponent, LnIconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SharingComponent, FbIconComponent, TwIconComponent, LnIconComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharingModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...components
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    ...components
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of sharing
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SharingComponent, SharingModule, SharingService, FbIconComponent as ɵa, TwIconComponent as ɵb, LnIconComponent as ɵc };

//# sourceMappingURL=scoop-lli-sharing.js.map